import type { PaletteOptions } from '@mui/material/styles';
import type { customization } from './Theme';
/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(color: PaletteOptions, customization?: customization): PaletteOptions {
    return {
        ...color,
        mode: customization?.mode,
        common: {
            black: color.grey?.[900],
            white: color.background?.paper
        },
    };
}
